var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDollerBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 52,
    viewBox: "0 0 53 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26.5,
    cy: 26,
    r: 26,
    fill: "#1B254B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.7525 24.8104C23.6463 24.003 22.6473 23.1683 22.6473 21.8683C22.6473 20.3768 24.0294 19.3368 26.342 19.3368C28.2851 19.3368 29.2567 20.0757 29.6125 21.2525C29.7767 21.7999 30.2283 22.2104 30.803 22.2104H31.2135C32.1167 22.2104 32.7598 21.321 32.4451 20.4725C31.8704 18.8578 30.5293 17.5168 28.3946 16.9968V16.0526C28.3946 14.9168 27.4778 14 26.342 14C25.2062 14 24.2894 14.9168 24.2894 16.0526V16.9557C21.6347 17.5305 19.5 19.2547 19.5 21.8957C19.5 25.0567 22.1136 26.6304 25.9315 27.5472C29.3525 28.3682 30.0367 29.5724 30.0367 30.845C30.0367 31.7892 29.3662 33.2945 26.342 33.2945C24.0841 33.2945 22.921 32.4871 22.4694 31.3377C22.2642 30.804 21.7989 30.4208 21.2379 30.4208H20.8547C19.9379 30.4208 19.2947 31.3513 19.6368 32.1998C20.4168 34.1018 22.2368 35.2239 24.2894 35.6618V36.5786C24.2894 37.7144 25.2062 38.6313 26.342 38.6313C27.4778 38.6313 28.3946 37.7144 28.3946 36.5786V35.6892C31.063 35.1829 33.184 33.6366 33.184 30.8314C33.184 26.9451 29.8588 25.6177 26.7525 24.8104Z",
    fill: "#6AD2FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollerBlue);
export default __webpack_public_path__ + "static/media/doller-blue.6831ab90f92467b87d7b72290db4cb6c.svg";
export { ForwardRef as ReactComponent };